import axios from 'axios'
import store from '../store/'

var SRVAPI = null

if (!SRVAPI) {
    SRVAPI = axios.create()
    SRVAPI.defaults.baseURL = process.env.NODE_ENV === 'development' ?
        '/apiProxy/mastermeet/api' :
        '/mastermeet/api'
}

const getDefaultlHeaders = () => {
    return {
        "Accept-language": store.state.config.lang
    }
}

export default {

    GET: async () => {
        try {
            
        } catch (error) {
            console.log('API GET error', error)
        }
    },

    POST: async (api, postBody, customHeaders = {}) => {
        try {
            return await SRVAPI.post(`/${api}/`, postBody, {
                headers: {
                    ...getDefaultlHeaders(),
                    ...customHeaders
                }
            })
        } catch (error) {
            console.log('API POST error', error)
            throw error
        }
    },

    PATCH: async () => {
        try {
            
        } catch (error) {
            console.log('API PATCH error', error)
        }
    }

}